import React from "react";
import "./skills.css";
import data from "../../data/data";

const Skills = () => {
    return (
        <section className="app__skills d-flex flex-item-center">
            <div className="app__skills-container app__container">
                <div className="app__skills-header">
                    <h2> Skills & Profession </h2>
                </div>
                <div className="app__skills-body">
                    <div className="app__skills-row gap-1">
                        <div className="app__skills-col -left -skill">
                            <div className="-skill d-flex flex-item-center gap-1">
                                { data.skills.map(({ title, Icon, color="#fff", bg }) => (
                                    <div key={title} className="app__skills-skill d-flex flex-item-center gap-0">
                                        <p> { title } </p>
                                        { Icon && <Icon 
                                            color={color} 
                                            style={{ background: bg ? bg : "inherit" }} 
                                        /> }
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="app__skills-col -right -profession">
                            <div className="-profession">
                                { data.profession.slice(0,3).map(profession => (
                                    <div key={profession.id} className="app__skills-profession">
                                        <h4> { profession.title } </h4>
                                        <p dangerouslySetInnerHTML={{__html: profession.description}} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Skills;